export const CONNORS_STORAGE_KEY = "connors";

export function getConnorsPrefs() {
  if (typeof window === "undefined") {
    return null;
  }

  try {
    const raw = localStorage.getItem(CONNORS_STORAGE_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function shouldSkipConnorsAgeGate() {
  const prefs = getConnorsPrefs();
  return prefs?.landing === true;
}

export function shouldSkipConnorsApplyPopup() {
  const prefs = getConnorsPrefs();
  return prefs?.["pop-up"] === false;
}

export function saveConnorsLandingPrefs() {
  const prefs = getConnorsPrefs() || {};

  localStorage.setItem(
    CONNORS_STORAGE_KEY,
    JSON.stringify({
      landing: true,
      "pop-up": prefs["pop-up"] ?? true,
    })
  );
}

export function saveConnorsApplyPrefs() {
  const prefs = getConnorsPrefs() || {};

  localStorage.setItem(
    CONNORS_STORAGE_KEY,
    JSON.stringify({
      landing: prefs.landing ?? false,
      "pop-up": false,
    })
  );
}
